import React from 'react';
import { useTranslation } from 'react-i18next';
import { useBrandConfig } from "@/features/brandDemo/BrandConfigContext.jsx";

export const DemoContestHeader = ({ contestData, recentGoal }) => {
    const { t } = useTranslation();
    const { brand } = useBrandConfig();

    const coverUrl = contestData?.coverUrl;
    const goalColor = brand.colors.goalFlash;

    let containerClasses = "relative bg-white rounded-b-[2rem] overflow-hidden transition-shadow duration-300";
    containerClasses += recentGoal ? " shadow-none" : " shadow-lg shadow-black/10";

    const imgClasses = contestData
        ? "w-full h-56 object-cover block"
        : "w-full h-56 object-cover block animate-fade-in";

    const goalStyles = `
        @keyframes flashRed {
            0% { opacity: 1; }
            100% { opacity: 0; }
        }
        @keyframes wipeCurtain {
            0% { transform: translateX(120%) skewX(-12deg); }
            100% { transform: translateX(-10%) skewX(-12deg); }
        }
        @keyframes wipeText {
            0% { transform: translateX(-150%); opacity: 0; }
            100% { transform: translateX(0); opacity: 1; }
        }
        @keyframes wipeSub {
            0% { transform: translateX(150%); opacity: 0; }
            100% { transform: translateX(0); opacity: 1; }
        }
        @keyframes pulseText {
            0%, 100% { transform: translateX(0) scale(1); }
            50% { transform: translateX(0) scale(1.08); text-shadow: 0 0 20px rgba(255,255,255,0.4); }
        }
        .anim-flash    { animation: flashRed 0.4s ease-out forwards; }
        .anim-curtain  { animation: wipeCurtain 0.5s cubic-bezier(0.16, 1, 0.3, 1) 0.15s forwards; transform: translateX(120%) skewX(-12deg); }
        .anim-text     { animation: wipeText 0.5s cubic-bezier(0.16, 1, 0.3, 1) 0.35s forwards, pulseText 1.2s ease-in-out 0.85s infinite; transform: translateX(-150%); opacity: 0; }
        .anim-sub      { animation: wipeSub 0.5s cubic-bezier(0.16, 1, 0.3, 1) 0.5s forwards; transform: translateX(150%); opacity: 0; }
    `;

    return (
        <div className={containerClasses}>
            {coverUrl && (
                <img src={coverUrl} alt="Header" className={imgClasses} />
            )}

            {recentGoal && (
                <div className="absolute inset-0 z-10 bg-white rounded-b-[2rem] flex flex-col items-center justify-center overflow-hidden">
                    <style dangerouslySetInnerHTML={{ __html: goalStyles }} />

                    <div className="absolute inset-0 z-40 anim-flash pointer-events-none" style={{ backgroundColor: goalColor }} />
                    <div className="absolute inset-0 w-[120%] z-10 anim-curtain" style={{ backgroundColor: goalColor }} />

                    <div className="relative z-20 flex flex-col items-center justify-center w-full">
                        <span className="anim-text font-black italic uppercase tracking-tighter text-white text-[4rem] sm:text-[5rem] md:text-[6rem] leading-none">
                            {t('overlay_goal.title', 'BUUUUT !')}
                        </span>
                        {typeof recentGoal === 'object' && recentGoal.teamName && (
                            <div className="anim-sub mt-2 bg-white px-8 py-1.5 font-black text-xl md:text-2xl uppercase tracking-widest transform -skew-x-12" style={{ color: goalColor }}>
                                <span className="transform skew-x-12 block">{recentGoal.teamName}</span>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};
